<template>
  <div class="songs">
    <h2>Songs</h2>
    <div class="container row">
      <div class="tag-container col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <b-form-group label="Tags">
          <b-form-checkbox
            v-for="(tag, idx) in tags"
            v-model="selectedTags"
            :key="idx"
            :value="tag"
            name="tags"
            v-on:change="filterSongs()"
            size="sm"
          >
            {{ tag }}
          </b-form-checkbox>
        </b-form-group>
        <span class="clear" v-on:click="clearAllTags()"
          ><v-icon class="x-circle" name="x-circle"></v-icon> Clear all</span
        >
      </div>
      <div class="list col-xs-12 col-sm-12 col-md-8 col-lg-8">
        <div class="sort">
          <div
            :class="
              `name ${currentSort === 'name' ? 'active' : 'inactive'} ${
                desc ? 'desc' : 'asc'
              }`
            "
            v-on:click="clickSort"
          >
            Name
          </div>
          <div
            :class="
              `lastUpdated ${
                currentSort === 'lastUpdated' ? 'active' : 'inactive'
              } ${desc ? 'desc' : 'asc'}`
            "
            v-on:click="clickSort"
          >
            Last Updated
          </div>
          <div
            :class="
              `avarageRating ${
                currentSort === 'avarageRating' ? 'active' : 'inactive'
              } ${desc ? 'desc' : 'asc'}`
            "
            v-on:click="clickSort"
          >
            Rating
          </div>
        </div>
        <hr />
        <div class="song" v-for="(song, idx) in songs" :key="idx">
          <div class="link">
            <b-badge v-if="song.unread" class="total-comments" variant="success"
              ><v-icon class="message-square" name="message-square"></v-icon
              >{{ song.comments }}</b-badge
            >
            <b-badge v-else class="total-comments" variant="light"
              ><v-icon class="message-square" name="message-square"></v-icon
              >{{ song.comments }}</b-badge
            >
            <router-link :to="{ path: `/song/${song.key}` }"
              ><span class="title">{{ song.name }}</span> -
              <span class="date">{{ song.date }}</span></router-link
            >
            <b-badge
              class="avarage"
              pill
              :variant="getVariant(song.avarageRating)"
              >{{ song.avarageRating }}</b-badge
            >
          </div>
          <div class="tags">
            <b-badge
              v-for="(tag, idy) in song.tags"
              :key="idy"
              variant="info"
              >{{ tag }}</b-badge
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.songs {
  .container {
    text-align: left;

    .tag-container {
      margin-bottom: 50px;
    }

    .clear {
      cursor: pointer;

      svg {
        height: 14px;
        width: auto;
        margin: 2px;
      }
    }

    .list {
      .sort {
        font-size: 14px;

        display: flex;

        div {
          margin-right: 10px;
        }

        .active {
          font-weight: bold;

          &.desc::after {
            content: " ";
            display: inline-block;
            margin: 0 0 2px 1px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid rgb(44, 62, 80);
          }
          &.asc::after {
            content: " ";
            display: inline-block;
            margin: 0 0 2px 1px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid transparent;
            border-bottom: 5px solid rgb(44, 62, 80);
          }
        }

        .inactive {
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
      .song {
        margin: 15px 0;
        a {
          color: #2c3e50;
        }
        .total-comments {
          margin-right: 4px;
          svg {
            width: 12px;
            height: auto;
            margin-right: 2px;
          }
        }
        .avarage {
          margin-left: 5px;
          pointer-events: none;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
        }
      }
      .date {
        font-size: 12px;
      }
    }
  }

  // @media only screen and (max-width: 700px) {
  //   .tag-container {
  //     display: none;
  //   }
  // }
}
</style>

<script>
import { db, loggedInUser } from "../firebaseConfig";
import { getVariant } from "../utils";

export default {
  name: "songs",
  data() {
    return {
      songs: [],
      allSongs: [],
      selectedTags: [],
      tags: [],
      name: "",
      currentSort: "lastUpdated",
      desc: true,
    };
  },
  async created() {
    const currentUser = await loggedInUser;

    // Retrieve the sort state from localStorage
    const sortState = JSON.parse(localStorage.getItem('sortState'));
    if (sortState) {
      this.currentSort = sortState.currentSort;
      this.desc = sortState.desc;
    }

    // Retrieve the selected tags from localStorage
    const selectedTags = JSON.parse(localStorage.getItem('selectedTags'));
    if (selectedTags) {
      this.selectedTags = selectedTags;
    }


    // Get songs
    db.collection("songs")
      .where("active", "==", true)
      .orderBy("lastUpdated", "desc")
      .get()
      .then((querySnapshot) => {
        this.songs = [];
        var tags = [];
        var promises = [];
        querySnapshot.forEach((doc) => {
          // Store tags
          if (doc.data().tags) {
            for (var i = 0; i < doc.data().tags.length; i++) {
              tags[tags.length] = doc.data().tags[i];
            }
          }

          // Sort tags
          this.tags = [...new Set(tags)]; // Remove duplicates
          this.tags.sort();

          // Get comments
          promises[promises.length] = db
            .collection("comments")
            .where("song", "==", doc.id)
            .get()
            .then((commentSnapshot) => {
              var unread = false;
              commentSnapshot.forEach((c) => {
                const comment = c.data();
                if (
                  comment.createdBy.uid !== currentUser.uid &&
                  comment.readBy &&
                  !comment.readBy[currentUser.uid]
                ) {
                  unread = true;
                  return;
                }
              });

              // Calculate avarage rating
              const allRating = doc.data().rating ? doc.data().rating : {};
              let avarageRating;
              // Calculate avarage rating
              let people = 0;
              let totalRating = 0;
              for (const key in allRating) {
                if (allRating.hasOwnProperty(key)) {
                  people++;
                  totalRating += allRating[key];
                }
              }
              avarageRating = isNaN(totalRating / people)
                ? undefined
                : (totalRating / people).toFixed(1);

              this.allSongs.push({
                key: doc.id,
                name: doc.data().name,
                date: new Date(doc.data().lastUpdated).toLocaleDateString(),
                lastUpdated: doc.data().lastUpdated,
                tags: doc.data().tags,
                comments: commentSnapshot.size,
                unread: unread,
                avarageRating: avarageRating,
              });
            });
        });

        Promise.all(promises).then(() => {
          // Then filter and display songs
          this.filterSongs();
        });
      });
  },
  methods: {
    deleteSong(id) {
      db.collection("song")
        .doc(id)
        .delete();
    },
    clearAllTags() {
      this.selectedTags = [];
      this.filterSongs();
    },
    filterSongs() {
      setTimeout(() => {
        // Save the selected tags to localStorage
        localStorage.setItem('selectedTags', JSON.stringify(this.selectedTags));
        if (!this.selectedTags.length) {
          this.songs = this.allSongs;
        } else {
          this.songs = [];
          // Loop all songs
          for (var i = 0; i < this.allSongs.length; i++) {
            // Make sure song has tags
            if (this.allSongs[i].tags) {
              // Loop all tags
              for (var j = 0; j < this.allSongs[i].tags.length; j++) {
                if (this.selectedTags.indexOf(this.allSongs[i].tags[j]) > -1) {
                  this.songs[this.songs.length] = this.allSongs[i];
                  break;
                }
              }
            }
          }
        }
        this.sortSongs(this.currentSort);
      }, 50);
    },
    clickSort(e) {
      this.sortSongs(
        e.target.classList[0],
        e.target.classList.contains("active")
      );
    },
    sortSongs(sort, changeDirection) {
      if (changeDirection) this.desc = !this.desc;
      this.currentSort = sort;

      // Save the sort state to localStorage
      localStorage.setItem('sortState', JSON.stringify({
        currentSort: this.currentSort,
        desc: this.desc
      }));

      this.songs.sort((a, b) => {
        // Check for undefined (rating)
        a = a[sort] === undefined ? 0 : a[sort];
        b = b[sort] === undefined ? 0 : b[sort];
        // Check for string or number
        if (isNaN(a)) {
          // String
          if (a < b) {
            return this.desc ? -1 : 1;
          }
          if (a > b) {
            return this.desc ? 1 : -1;
          }
          return 0;
        } else {
          // Number
          if (this.desc) return b - a;
          else return a - b;
        }
      });
    },
    getVariant: getVariant,
  },
};
</script>
